import { Map as IMap } from 'immutable';

const currencyFractionMap = IMap({
    DEFAULT: 2,
    JPY: 0,
    USD: 2
});

export default currencyFractionMap;
